import { render, staticRenderFns } from "./CurrentOrderItem.vue?vue&type=template&id=f483fb04&"
import script from "./CurrentOrderItem.vue?vue&type=script&lang=js&"
export * from "./CurrentOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports